<template>
  <li class="c-tab-wrapped-item">
    <button
      type="button"
      class="c-tab-wrapped-item__button"
      :class="{ active: item.isSelected }"
      @click="$emit('tab-item-clicked')"
    >
      {{ item.title }}
    </button>
  </li>
</template>

<script>
export default {
  name: 'ComponentTabWrappedItem',
  props: {
    item: {
      type: Object,
      default: () => {
        return { title: 'title' }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
@use '~/scss/generic/variables';

.c-tab-wrapped-item {
  &__button {
    border-radius: 50px;
    font-size: 13px;
    font-weight: 600;
    line-height: 36px;
    padding: 0 12px;
    transition: background-color 0.3s;
    white-space: nowrap;

    &.active {
      background-color: variables.$color-accent;
      color: #fff;
    }
  }
}
</style>
